<template>
    <div class="position-box selectCurrency">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('bzxz.title')}}</div>
        </div>
        <div class="cotainer selectCurrency">
            <ul class="ul-box">
               <li class="li" @click="select2" v-show="hasBank == 1 && url == 'withdraw'">
                 <template v-if="lang == 'ar'">
                    <div class="text">{{$t('tibi.yhktx')}}</div>
                    <img class="icon" src="@/assets/yinhangka.png" alt="">
                  </template>
                  <template v-else>
                    <img class="icon" src="@/assets/yinhangka.png" alt="">
                    <div class="text">{{$t('tibi.yhktx')}}</div>
                  </template>
              </li>
              <li class="li" v-for="(item,index) in bzData" :key="index" @click="select(item.name)">
                  <template v-if="lang == 'ar'">
                    <div class="text">{{item.name}}</div>
                    <img class="icon" style="margin-left: .2rem" :src="item.icon" alt="">
                  </template>
                  <template v-else>
                    <img class="icon" :src="item.icon" alt="">
                    <div class="text">{{item.name}}</div>
                  </template>
              </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectCurrency',
    data () {
        return {
            theme: false,
            url: '',
            type: 1,
            bzData: [],
            lang: 'en',
            hasBank: '',
        }
    },
    created(){
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.url = this.$route.query.url;
        this.type = this.$route.query.type;
        this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getmarketList();
        this.hasBankinfo();
    },
    methods: {
       back(){
           this.$router.go(-1)
       },
       select2(){
         localStorage.setItem('bz','USDT');
         this.$router.push({ path: '/withdraw', query: { type: 1,currency: 'USDT',hasBank: 1,check: true } })
       },
       hasBankinfo(){
        this.$ajax.get('/web/hasBankinfo',{}).then((res) => {
              let resData = res.data.data;
              this.hasBank = resData;
          }).catch(function(err){
              console.log(err)
          })
      },
       getmarketList(){
           let params = {
               id: 1
           }
           this.$ajax.get('/web/getCurrency',{params}).then((res) => {
                let resData = res.data.data;
                this.bzData = resData;
            }).catch(function(err){
                console.log(err)
            })
       },
       select(bz){
            localStorage.setItem('bz',bz);
            if(this.url == 'deposit'){
                this.$router.push({ path: '/deposit', query: { type: 1,currency: bz } })
            }else{
                this.$router.push({ path: '/withdraw', query: { type: 1,currency: bz } })
            }
       }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .ul-box{
        padding: 0 .3rem;
        background: #fff;
    }
    .cotainer .ul-box .li{
        position: relative;
        display: flex;
        align-items: center;
        padding: .4rem 0;
        color: #000;
        font-size: .42rem;
        border-bottom: 1px solid #b0bfd7;
    }
    .cotainer .ul-box .li .icon{
        width: .72rem;
        margin-right: .2rem;
        border-radius: 50%;
    }
    .cotainer .ul-box .li:last-child{
        border-bottom: none;
    }
    .cotainer .ul-box .li .arrow{
        position: absolute;
        right: .2rem;
        width: 15px;
        height: 8px;
        border-left: 2px solid #4bb3e8;
        border-bottom: 2px solid #4bb3e8;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }
</style>



// WEBPACK FOOTER //
// src/pages/selectCurrency.vue